import Presets from './Presets.graphql';
import Preset from './Preset.graphql';
import CreatePreset from './CreatePreset.graphql';
import UpdatePreset from './UpdatePreset.graphql';
import DeletePreset from './DeletePreset.graphql';

const PresetsQuery = Presets;
const PresetQuery = Preset;
const CreatePresetMutation = CreatePreset;
const UpdatePresetMutation = UpdatePreset;
const DeletePresetMutation = DeletePreset;

export {
  PresetsQuery,
  PresetQuery,
  CreatePresetMutation,
  UpdatePresetMutation,
  DeletePresetMutation,
};
